/* eslint-disable no-restricted-imports */
import { withSentryReactRouterV6Routing } from "@sentry/react";
import type { To } from "history";
import { Routes } from "react-router-dom";

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

/* eslint-disable import/export */
export * from "react-router-dom";
export { SentryRoutes as Routes, type To };
